import React from 'react'

import { useGlobalContext } from './context'

const Stories = () => {
  const { isLoading, hits, removeStory } = useGlobalContext();

  if (isLoading) {
    return <div className="loading"></div>;
  }

  return (
    <section className="stories">
      {hits.map((hit) => {
        const { objectID, title, num_comments, url, points, author } = hit;
        return (
          <article className="story" key={objectID}>
            <h4>{title}</h4>
            <p className="info">
              {points}{' points'} by <span>{author}</span> | {num_comments}{' comments'}
            </p>
            <div>
              <a href={url} target="_blank" rel="noopener noreferrer" className='read-link'>read more</a>
              <button onClick={() => removeStory(objectID)} className='remove-btn'>remove</button>
            </div>
          </article>
        );
      })}
    </section>
  );
}

export default Stories
